import React, { useEffect, useState } from 'react';
import { ArrowUpIcon } from 'lucide-react';
export function BackToTop() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const scrollToTop = () => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({
      top: 0,
      behavior: reduceMotion ? 'auto' : 'smooth'
    });
  };
  return <button type="button" onClick={scrollToTop} tabIndex={visible ? 0 : -1} aria-hidden={!visible} className={`fixed bottom-6 right-6 z-40 inline-flex items-center gap-2 rounded-full bg-purple-700 pl-4 pr-5 py-3 text-sm font-medium text-white shadow-lg transition-[opacity,transform] duration-200 ease-out hover:bg-purple-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-600 focus-visible:ring-offset-2 focus-visible:ring-offset-ivory ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2 pointer-events-none'}`} data-id="element-279" data-mp="rs8pl40qlacp">
      <ArrowUpIcon aria-hidden="true" className="w-4 h-4" data-id="element-280" data-mp="3frq892zdnqf8" />
      Back to top
    </button>;
}